<template>
	<div>
		<NavMenu @memberAudit='memberAuditFn' />
		<div class="MemberServicesWarp">
			<el-image :src="img2" class="imgbox" v-if='memberAudit==1'></el-image>
			<el-image :src="img1" class="imgbox" v-else @click="goapplyFn" style="cursor: pointer;"></el-image>
			<div class="typeArae">
				<div class="primaryTitle">
					<span class="left-line"></span>
					<span class="title">会员名录</span>
					<span class="right-line"></span>
				</div>
				<div class="membersListBox">
					<div class="rightMore">
						<div class="search-box">
							<!-- <input type="text" v-model="msg"> -->
							<el-input type="text" v-model="searchVal" placeholder="请输入搜索内容" @keydown.enter.native="serchEnterFn" class="input-with-select">
							</el-input>
							<img src='@/assets/imgs/home/searchicon.png' @click.stop="serchEnterFn" />
						</div>
						<span class="morebox" @click="gonewsecond1">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="listbox" v-if='memberList.length!=0'>
						<!-- <div class="aloneInfoItem">
						<div class="memberName">会员机构名称</div>
						<div class="memberGrade">会员机构名称</div>
						<div class="memberSite">
							<i class="el-icon-location iconwarp" />会员机构名称</div>
					</div> -->
						<div class="aloneInfoItem" v-for="(item,index) in memberList" :key="index" @click="showremarkFn(item.remark)">
							<div class="memberName overflowone">{{item.corpInfoName}}</div>
							<div class="memberGrade">{{item.memberlevel}}</div>
							<div class="memberSite" v-if="item.regionalCode">
								<i class="el-icon-location iconwarp" />{{item.regionalCode}}
							</div>
						</div>
					</div>
					<div class="emptyBox" v-else>
						 <img src="@/assets/imgs/home/emptyimg.png" />
					</div>
				</div>
				<div class="primaryTitle">
					<span class="left-line"></span>
					<span class="title">会员风采</span>
					<span class="right-line"></span>
				</div>
				<div class="membersBox">
					<div class="rightMore" @click="gonewsecond2">
						<span class="morebox">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="textinImgtopbox" v-if="newsDataBox1.length!=0">
						<div v-for="(item,index) in newsDataBox1" :key="index" class="newsItembox" @click="goNewsDetailFn(item)">
							<img :src="srcUrl+item.titleImgUrl" class="imgbox" />
							<div class="contentbox">
								<div class="title overflowone">{{item.pressTopic}}</div>
								<div class="synopsis overflowtwo">{{item.synopsis}}</div>
							</div>
						</div>
					</div>
					<div class="emptyBox" v-else>
						 <img src="@/assets/imgs/home/emptyimg.png" />
					</div>
				</div>
				<div class="primaryTitle">
					<span class="left-line"></span>
					<span class="title">赋能会员</span>
					<span class="right-line"></span>
				</div>
				<div class="newsbox2">
					<div class="rightMore" @click="gonewsecond3">
						<span class="morebox">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="topImgbot4textBox" v-if="newsDataBox2.length!==0">
						<div v-for="(item,index) in newsDataBox2" :key="index" class="newsItembox" @click="goNewsDetailFn(item)">
							<img :src="srcUrl+item.titleImgUrl" class="imgbox" />
							<div class="contentbox">
								<div class="title overflowone">{{item.pressTopic}}</div>
								<div class="synopsis overflowtwo">{{item.synopsis}}</div>
								<div class="time">{{item.pressTime | timer}}</div>
							</div>
						</div>
					</div>
					<div class="emptyBox" v-else>
						 <img src="@/assets/imgs/home/emptyimg.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="footerbox">
			<Footer/>
		</div>
		<!-- 会员单位简介弹框 -->
		<!-- 弹框 -->
		<el-dialog title="简介" :visible.sync="remarkVisible" width="1200px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'
		    :append-to-body="true">
			<div class="singupdialogcenter">
				{{currentRemark?currentRemark:'暂无简介~'}}
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remarkVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
		NavMenu,
		Footer
	},
	data() {
		return {
			srcUrl: srcUrl,
			img1: require("@/assets/imgs/member/img1.png"),
			img2: require("@/assets/imgs/member/img2.png"),
			newsDataBox1: [],
			newsDataBox2: [],
			dialogVisible: false,
			searchVal: null,//搜索字段
			memberList: [],
			memberAudit: '',
			remarkVisible: false,
			currentRemark: null,
			token: sessionStorage.getItem('token')
		}
	},
	mounted() {
		this.getnews1()
		this.getnews2()
		this.getmember()
	},
	methods: {
		// 获取会员状态
		memberAuditFn(val){
			this.memberAudit=val
		},
		async getnews1() {
			let params = {
				pageSize: 8,
				pageCurrent: 1,
				pressSuperClass: 4,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsDataBox1 = data.result.list
			}
		},
		async getnews2() {
			let params = {
				pageSize: 4,
				pageCurrent: 1,
				pressSuperClass: 29,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsDataBox2 = data.result.list
			}
		},
		serchEnterFn() {
			this.getmember()
		},
		async getmember() {
			let params = {
				pageSize: 8,
				pageCurrent: 1,
				findAll: this.searchVal
			};
			let data = await httpService.findMember(params);
			if (data.code == 200) {
				this.memberList = data.result.list
			}
		},
		goNewsDetailFn(val) {
			this.$router.push({
				path: "/news-detail",
				query: {
					id: val.pressId,
				},
			});
		},
		gonewsecond1() {
			this.$router.push('/member-secondpage/member');
		},
		gonewsecond2() {
			this.$router.push('/member-secondpage/member-style');
		},
		gonewsecond3() {
			this.$router.push('/member-secondpage/energize-member');
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => { });
		},
		showremarkFn(val) {
			this.currentRemark = val;
			this.remarkVisible = true
		},
		goapplyFn() {
			if (this.token) {

				this.$router.push('/account-center/expert-database');
			} else {
				this.$message({
					message: '请先登录网站',
					type: 'warning'
				});
			}
		}
	},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		},
	},
}
</script>
<style lang="less" scoped>
.MemberServicesWarp {
	width: 100%;
	margin: 0 auto;
	.imgbox {
		width: 100%;
		// height: 300px;
	}
	.membersListBox {
		width: 1200px;
		margin: 0 auto;
		.rightMore {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			.search-box {
				// background: #1088fe;
				width: 266px;
				justify-content: center;
				align-items: center;
				align-content: center;
				text-align: center;
				// padding: 30px 0px;
				height: 40px;
				display: flex;
				flex-direction: row;
				margin-right: 32px;
				position: relative;
				/deep/.el-input__inner {
					// background-color: #68b4ff;
					border: 1px solid #cacaca;
					color: #000 !important;
					border-radius: 20px;
				}
				/deep/input::placeholder {
					color: #cacaca !important;
				}
				img {
					position: absolute;
					// height: 40px;
					// width: 40px;
					right: 5px;
					cursor: pointer;
				}
			}
			.morebox {
				margin-top: 0;
			}
		}
		.listbox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			padding-top: 16px;
		}
		.aloneInfoItem {
			margin: 0 16px 30px 0;
			width: 288px;
			height: 178px;
			background: rgba(255, 255, 255, 0.39);
			border: 1px solid #e7e7e7;
			padding: 20px 0 0 0;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			cursor: pointer;
			&:hover {
				box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
				// background:  linear-gradient(90deg, #448DF7 0%, #9BBEFF 100%) ;
				background: url(../assets/imgs/member/bgimg.png) #5e97ee no-repeat 100%;
				.memberName,
				.memberSite {
					color: #fff;
				}
				.memberName::before {
					border: 2px solid #fff;
					opacity: 1;
					background: #fff;
				}

				.memberSite {
					.iconwarp {
						color: #fff;
					}
				}
			}
			&:nth-child(4n) {
				margin-right: 0;
			}
			.memberName {
				width: 95%;
				font-size: 18px;
				font-weight: 500;
				line-height: 32px;
				color: #333333;
				position: relative;
				text-align: center;
			}
			.memberName::before {
				content: '';
				position: absolute;
				width: 44px;
				height: 0px;
				border: 2px solid #448df7;
				opacity: 1;
				background: #448df7;
				left: 50%;
				transform: translateX(-50%);
				top: 32px;
			}
			.memberGrade {
				width: 161px;
				height: 32px;
				background: #fad65c;
				font-size: 16px;
				line-height: 32px;
				color: #7a4702;
				text-align: center;
				margin: 25px 0 10px 0;
			}
			.memberSite {
				font-size: 16px;
				line-height: 32px;
				color: #999999;
				.iconwarp {
					font-size: 18px;
					color: #448df7;
					margin-right: 2px;
				}
			}
		}
	}
	.membersBox {
		width: 1200px;
		min-height: 412px;
		margin: 0 auto;
		.textinImgtopbox {
			width: 100%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.newsItembox {
				width: 282px;
				margin: 0 24px 23px 0;
				cursor: pointer;
				// img {
				// 	transition: all 2s;
				// }
				&:hover {
					.contentbox {
						// height: 80%;
						// background: rgba(0, 0, 0, 0.39);
						background: linear-gradient(360deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1));
						// bottom: 16px;
						z-index: 99;
					
					}
				}
				&:nth-child(4n) {
					margin-right: 0;
				}
				position: relative;
				.imgbox {
					width: 282px;
					height: 206px;
				}
				.contentbox {
					width: 100%;
					padding: 0 12px 0 18px;
					box-sizing: border-box;
					position: absolute;
					bottom: 4px;
					left: 0;
					// min-height: 96px;
					z-index: 99;
					padding-bottom: 16px;
					// bottom: 0;
					// right: 0;
					width: 100%;
					height: 112px;
					// color: #fff;
					display: flex;
					flex-direction: column;
					pointer-events: none;
					transition: all 2s;
					z-index: -1;
					.title {
						font-size: 20px;
						font-weight: 500;
						line-height: 36px;
						color: #fff;
					}
					.synopsis {
						font-size: 16px;
						line-height: 30px;
						color: #fff;
					}
				}
			}
		}
	}
	.newsbox2 {
		width: 1200px;
		margin: 0 auto;
		.newsItembox {
			cursor: pointer;
			
		}
		.imgbox {
			height: 186px;
		}
	}
	.dialogcenter {
		padding: 17px 60px 10px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
}
.dialogWarp {
	/deep/.singupdialogcenter {
		font-size: 16px;
		line-height: 36px;
		text-indent: 32px;
		padding: 0 20px;
	}
}
</style>


